/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
/* eslint-disable */
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// import '../libs/form-place';
//
// import '../screen/screen.sass';

import 'swiper/swiper-bundle.css'
import {
  burger,
  footerTablet,
  headerFixed,
  homeAnimate,
  homePage,
  popup,
  scrollTop,
} from 'components/index'

const componentRequireContext = require.context('components', true)
const ReactRailsUJS = require('react_ujs')

ReactRailsUJS.useContext(componentRequireContext)

function init() {
  /* Global */
  burger.init()
  homePage.init()
  homeAnimate.init()
  scrollTop.init()
  footerTablet.init()
  headerFixed.init()
  popup.init()
}

window.addEventListener('DOMContentLoaded', () => {
  init()
})
/* eslint-enable */
